/**
 * Main navigation items configuration.
 *
 * Each item can have:
 * - label: Display text (required)
 * - href: Link URL (required for regular items, optional for dropdowns)
 * - urlPrefix: URL path prefix for startsWith matching against window.location.pathname (preferred)
 * - activeUrls: Array of URL paths when multiple unrelated URLs need to match
 * - pathPrefix: Controller path for startsWith matching against store.currentPath (legacy fallback)
 * - activePaths: Array of controller paths when multiple unrelated paths need to match (legacy fallback)
 * - show: Function receiving store to determine visibility
 * - items: Array of dropdown items (makes this a dropdown)
 * - dynamicLabel: Function receiving store to compute label dynamically
 *
 * URL-based matching (urlPrefix/activeUrls) is checked first. If no URL fields are present,
 * falls back to controller-path matching (pathPrefix/activePaths).
 */
export default [
  {
    label: 'Locations',
    href: '/locations',
    pathPrefix: 'locations'
  },
  {
    label: 'Reviews',
    href: '/reviews_dashboard',
    pathPrefix: 'reviews_dashboard',
    show: (store) => store.hasFeature('reviews_dashboard')
  },
  {
    label: 'Bulk Posting',
    pathPrefix: 'gmb',
    activePaths: [
      '/gmb/multi_location_media',
      '/gmb/multi_location_posts',
      '/gmb/local_posts/bulk_posts'
    ],
    show: (store) => {
      if (!store.user.editor) return false
      const isLinda = store.wlc.appCodename === 'linda'
      if (isLinda && !store.organization.allowBulkPostingForLinda) return false
      return true
    },
    items: [
      { label: 'Multi Media', href: '/gmb/multi_location_media' },
      { label: 'Multi Posts', href: '/gmb/multi_location_posts' },
      { label: 'Bulk Posts', href: '/gmb/local_posts/bulk_posts' }
    ]
  },
  {
    label: 'GeoGrid Search',
    href: '/scheduled_geogrids_index',
    activePaths: ['geogrids', 'geogrid_widgets', 'geogrid_requests', 'scheduled_geogrids']
  },
  {
    label: 'Reports',
    href: '/reports',
    activePaths: ['reports', 'report_configurations', 'audit_report_configurations', 'audit_reports'],
    show: (store) => !store.user.viewer
  },
  {
    label: 'Gallery',
    href: '/gallery',
    activePaths: ['galleries', 'media_schedules'],
    show: (store) => !store.user.viewer
  },
  {
    label: 'GeoBooster',
    href: '/gb',
    urlPrefix: '/gb/',
    pathPrefix: 'mobile',
    show: (store) => !store.user.viewer && store.hasFeature('gb'),
    dynamicLabel: (store) => store.wlc.gbName
  },
  {
    label: 'Call Tracking',
    href: '/call_tracking/incoming_calls',
    pathPrefix: 'jensen',
    show: (store) => !store.user.viewer && store.hasFeature('jensen')
  },
  {
    label: 'Form Tracking',
    href: '/form_tracking/widgets',
    pathPrefix: 'form_tracking',
    show: (store) => !store.user.viewer && store.hasFeature('form_tracking')
  },
  {
    label: 'MLAP',
    href: '/mlap',
    urlPrefix: '/mlap',
    pathPrefix: 'mlap'
  },
  {
    label: 'LSA',
    href: '/lsa/dashboard',
    urlPrefix: '/lsa/',
    pathPrefix: 'lsa',
    show: (store) => store.hasFeature('lsa')
  }
]
